// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchIcon__root--3H0Up","focused":"SearchIcon__focused--h3Jo4"};